import { Map } from 'mapbox-gl';
import React, { useEffect } from 'react';
import { MapboxBasicProps } from '../Basic';

interface ValidationsProps extends MapboxBasicProps {
  map: Map;
}

export const Validations = ({ map, ...props }: ValidationsProps) => {
  /* Warn the developers for all required stuff */
  useEffect(() => {
    /* Only run the checking after the Map has been initialized */
    if (!map) {
      return;
    }

    const throwError = (conditional: boolean, missingProps: string) => {
      if (conditional) {
        console.error(
          `The \`${missingProps}\` was missing for the BasicMap usage`
        );
      }
    };

    /* Requrement for Order Marker */
    throwError(props.hasOrders && !props.orders, 'orders');
    throwError(props.hasOrders && !props.selectedOrders, 'selectedOrders');
    throwError(props.hasOrders && !props.selectedOrderIds, 'selectedOrderIds');
    throwError(props.hasOrders && !props.windowGroups, 'windowGroups');
    throwError(props.hasOrders && !props.fetchedBundles, 'fetchedBundles');
    throwError(
      props.hasOrders && !props.onClickOrderMarker,
      'onClickOrderMarker'
    );

    /* Requirement for Bundle Marker */
    throwError(props.hasBundle && !props.bundles, 'bundles');
    throwError(props.hasBundle && !props.windowGroups, 'windowGroups');
    throwError(props.hasBundle && !props.fetchedBundles, 'fetchedBundles');
    throwError(props.hasBundle && !props.selectedOrders, 'selectedOrders');
    throwError(props.hasBundle && !props.selectedOrderIds, 'selectedOrderIds');
    throwError(
      props.hasBundle && !props.onClickOrderMarker,
      'onClickOrderMarker'
    );
    throwError(
      props.hasBundle && !props.updateBundleFromPusher,
      'updateBundleFromPusher'
    );

    /* Requirement for Multi Marker */
    throwError(props.hasMultiMarker && !props.multiMarkers, 'multiMarkers');
    throwError(props.hasMultiMarker && !props.selectedOrders, 'selectedOrders');
    throwError(
      props.hasMultiMarker && !props.selectedOrderIds,
      'selectedOrderIds'
    );
    throwError(props.hasMultiMarker && !props.windowGroups, 'windowGroups');
    throwError(props.hasMultiMarker && !props.fetchedBundles, 'fetchedBundles');
    throwError(
      props.hasMultiMarker && !props.onClickOrderMarker,
      'onClickOrderMarker'
    );

    /* Requirement for Draw Polygon */
    throwError(
      props.enableDraw && props.shouldClearPolygon === undefined,
      'shouldClearPolygon'
    );
    throwError(
      props.enableDraw && !props.resetPolygonDrawing,
      'resetPolygonDrawing'
    );
    throwError(
      props.enableDraw && !props.onCreatePolygonDrawing,
      'onCreatePolygonDrawing'
    );
    throwError(
      props.enableDraw && !props.onUpdatePolygonDrawing,
      'onUpdatePolygonDrawing'
    );

    /* Requirement for Zones Overlay */
    throwError(
      props.hasZonesOverlay && !props.zonesOverlayType,
      'zonesOverlayType'
    );
    throwError(
      props.hasZonesOverlay && !props.onClickZonesOverlay,
      'onClickZonesOverlay'
    );
    throwError(
      props.hasZonesOverlay && !props.zonesOverlayObjects,
      'zonesOverlayObjects'
    );

    /* Requirement for Pinpoint */
    throwError(props.hasPinpoint && !props.pinpointData, 'pinpointData');
    throwError(
      props.pinpointDraggable && !props.onDragEndPinpoint,
      'onDragEndPinpoint'
    );
    throwError(props.pinpointIsUsingHubAsDefault && !props.region, 'region');
  }, [
    props.bundles,
    props.hasBundle,
    props.hasMultiMarker,
    props.hasOrders,
    props.multiMarkers,
    props.orders,
    props.selectedOrders,
    props.selectedOrderIds,
    props.windowGroups,
    props.fetchedBundles,
    props.enableDraw,
    props.shouldClearPolygon,
    props.hasZonesOverlay,
    props.zonesOverlayType,
    props.zonesOverlayObjects,
    props.hasPinpoint,
    props.pinpointData,
    props.pinpointDraggable,
    props.pinpointIsUsingHubAsDefault,
    props.region,
    props.onClickOrderMarker,
    props.updateBundleFromPusher,
    props.resetPolygonDrawing,
    props.onCreatePolygonDrawing,
    props.onUpdatePolygonDrawing,
    props.onClickZonesOverlay,
    props.onDragEndPinpoint,
    map,
  ]);

  return <></>;
};
